import createStyled from '../../../../../node_modules/.pnpm/@emotion_styled@11.14.0_@emotion_react@11.14.0_@types_react@19.0.1_react@18.3.1__@types_react@19.0.1_react@18.3.1/node_modules/@emotion/styled/base/dist/emotion-styled-base.esm.js';

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var HubspotFormContainer = /*#__PURE__*/createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "etheofl0"
} : {
  target: "etheofl0",
  label: "HubspotFormContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "15h8e03",
  styles: "width:100%;max-width:100%;#hubspot-form-container{width:100%;max-width:100%;}"
} : {
  name: "15h8e03",
  styles: "width:100%;max-width:100%;#hubspot-form-container{width:100%;max-width:100%;}/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkh1YnNwb3RGb3JtLnN0eWxlcy5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFOEMiLCJmaWxlIjoiSHVic3BvdEZvcm0uc3R5bGVzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5cbmV4cG9ydCBjb25zdCBIdWJzcG90Rm9ybUNvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gIHdpZHRoOiAxMDAlO1xuICBtYXgtd2lkdGg6IDEwMCU7XG5cbiAgI2h1YnNwb3QtZm9ybS1jb250YWluZXIge1xuICAgIHdpZHRoOiAxMDAlO1xuICAgIG1heC13aWR0aDogMTAwJTtcbiAgfVxuYFxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

export { HubspotFormContainer };
//# sourceMappingURL=HubspotForm.styles.js.map
